<div id="app" :class="{ 'risk-page': isRisk(), 'preload': preload }">
  <ErrorPage v-if='isErrorPage()' :page="errorPageData" />
  <NotFoundErrorPage v-else-if="isNotFoundErrorPage()" :data="errorPageData" />
  <RiskWarningPage v-else-if="isRisk()" :page="pageData" />
  <router-view v-else :page="pageData" :key="$route.path" />
</div>
